import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { notEmpty } from "@crehana/utils";
import parseTrailerSources from "./parseTrailerSources";
var parseCourseFragment = function parseCourseFragment(course) {
  return _objectSpread(_objectSpread({}, course), {}, {
    courseType: course.courseTypeEnum || course.courseType,
    trailerSources: parseTrailerSources({
      trailerSource: course.trailerSource
    }),
    subtitleList: course.subtitleList ? course.subtitleList.filter(notEmpty).filter(function (subtitle) {
      return !!subtitle.subtitleFile;
    }) : [],
    availableSubtitleLangs: (course.subtitle || []).filter(notEmpty),
    isSavedCourse: !!course.isSavedCourse
  });
};
export default parseCourseFragment;